/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'info': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="#C4FFF9" fill-rule="nonzero"><path pid="0" d="M75 32c-23.699 0-43 19.301-43 43s19.301 43 43 43 43-19.301 43-43-19.301-43-43-43zm0 80c-20.398 0-37-16.602-37-37s16.602-37 37-37 37 16.602 37 37-16.602 37-37 37z"/><path pid="1" d="M75 66c-1.7 0-3 1.3-3 3v23c0 1.7 1.3 3 3 3s3-1.3 3-3V69c0-1.7-1.3-3-3-3zm0-11c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"/></g>'
  }
})
